import React from 'react';
import '../styles/Skills.css';

function Skills() {
    const skillCategories = [
        {
            title: "Programming Languages",
            icon: "⟨/⟩",
            skills: [
                { name: "C++", icon: "⟨/⟩", desc: "Systems & embedded programming", level: 4, delay: 0 },
                { name: "Python", icon: "🐍", desc: "Scripting & data processing", level: 4, delay: 0 },
                { name: "JavaScript", icon: "JS", desc: "Dynamic web interactions", level: 3, delay: 0 }
            ]
        },
        {
            title: "Web Development",
            icon: "🌐",
            skills: [
                { name: "HTML", icon: "◇", desc: "Structuring web content", level: 5, delay: 0 },
                { name: "CSS", icon: "✦", desc: "Styling & animations", level: 4, delay: 0 },
                { name: "ReactJS", icon: "⚛", desc: "Component-based UI", level: 3, delay: 0 }
            ]
        },
        {
            title: "Engineering Tools",
            icon: "⚙️",
            skills: [
                { name: "Arduino", icon: "∞", desc: "Microcontroller programming", level: 4, delay: 0 },
                { name: "MATLAB", icon: "∑", desc: "Numerical computing", level: 3, delay: 0 },
                { name: "Proteus", icon: "⚡", desc: "Circuit simulation & PCB", level: 3, delay: 0 }
            ]
        },
        {
            title: "Design & Dev Tools",
            icon: "🎨",
            skills: [
                { name: "Canva", icon: "🎨", desc: "Graphic & visual design", level: 5, delay: 0 },
                { name: "Figma", icon: "✏️", desc: "UI/UX prototyping", level: 3, delay: 0 },
                { name: "VS Code", icon: "{ }", desc: "Primary code editor", level: 5, delay: 0 },
                { name: "Cursor", icon: "▷", desc: "AI-powered coding", level: 4, delay: 0 }
            ]
        },
        {
            title: "Soft Skills",
            icon: "💡",
            skills: [
                { name: "Teamwork", icon: "◈", desc: "Collaborative mindset", level: 5, delay: 0 },
                { name: "Problem Solving", icon: "✧", desc: "Analytical thinking", level: 4, delay: 0 },
                { name: "Communication", icon: "◉", desc: "Clear & concise expression", level: 4, delay: 0 }
            ]
        }
    ];

    const renderStars = (level) => {
        return Array.from({ length: 5 }, (_, i) => (
            <span key={i} className={`skill-star ${i < level ? 'filled' : 'empty'}`}>★</span>
        ));
    };

    return (
        <section id="skills" className="skills-section">
            <div className="skills-ambient skills-ambient--1" />
            <div className="skills-ambient skills-ambient--2" />

            <div className="skills-header">
                <h2 className="section-title">Technical Skills</h2>
                <p className="skills-intro">
                    A blend of software, hardware, and design skills built through coursework,
                    personal projects, and hands-on engineering experience.
                </p>
            </div>

            <div className="skills-grid">
                {skillCategories.map((cat, index) => (
                    <div key={index} className="skills-category">
                        <h3 className="skills-category-title">{cat.icon} {cat.title}</h3>
                        <div className="skills-list">
                            {cat.skills.map((skill, idx) => (
                                <div key={idx} className="skill-item">
                                    <div className="skill-item-top">
                                        <span className="skill-item-icon">{skill.icon}</span>
                                        <span className="skill-item-name">{skill.name}</span>
                                        <span className="skill-item-stars">{renderStars(skill.level)}</span>
                                    </div>
                                    <p className="skill-item-desc">{skill.desc}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default Skills;
